import './styles.scoped.css';
export default {
  "dimmed": "awsui_dimmed_10ipo_ke9g5_93",
  "root": "awsui_root_10ipo_ke9g5_120",
  "list": "awsui_list_10ipo_ke9g5_131",
  "list-item": "awsui_list-item_10ipo_ke9g5_138",
  "key": "awsui_key_10ipo_ke9g5_143"
};